import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useToast,
} from "@chakra-ui/react";
import { DatePicker } from "antd";
import axios from "axios";
import API_BASE_URL from "../../apiConfig";
import dayjs from "dayjs";

const EditResignDateModal = ({ isOpen, onClose, employee, onUpdateSuccess }) => {
  const [resignationDate, setResignationDate] = useState(
    employee?.resignation_date ? dayjs(employee.resignation_date, "YYYY-MM-DD") : null
  );
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleUpdate = async () => {
    setLoading(true);
    const token = localStorage.getItem("access_token");
    try {
      await axios.patch(
        `${API_BASE_URL}/HumanResource/update_resign_date/${employee.id}/`,
        {
          resignation_date: resignationDate ? resignationDate.format("YYYY-MM-DD") : "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast({
        title: "Resignation date updated.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      onUpdateSuccess();
      onClose();
    } catch (error) {
      toast({
        title: "Error updating resignation date.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Update internal state when employee changes
  React.useEffect(() => {
    if (employee) {
      setResignationDate(employee.resignation_date ? dayjs(employee.resignation_date, "YYYY-MM-DD") : null);
    }
  }, [employee]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Resignation Date for {employee?.name}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <DatePicker
            style={{ width: "100%" }}
            value={resignationDate}
            onChange={(date) => setResignationDate(date)}
            format="YYYY-MM-DD"
            getPopupContainer={(trigger) => trigger.parentNode}
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleUpdate} isLoading={loading}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose} isDisabled={loading}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditResignDateModal;
